'use client'

import { useState, cloneElement, isValidElement, ReactElement } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import JoinArthavaVerseForm from "./jointArthaverseForm";

type JoinArthaverseProps = {
    children?: ReactElement<{ onClick?: (e?: any) => void }>;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    profId?: string;
};

const JoinArthaaverse = ({ children, open: controlledOpen, onOpenChange, profId }: JoinArthaverseProps) => {
    const [internalOpen, setInternalOpen] = useState(false);

    const isControlled = controlledOpen !== undefined;
    const open = isControlled ? controlledOpen : internalOpen;
    const handleOpenChange = (val: boolean) => {
        if (isControlled) {
            onOpenChange?.(val);
        } else {
            setInternalOpen(val);
        }
    };

    const trigger = isValidElement(children)
        ? cloneElement(children, {
            onClick: (e: any) => {
                children.props?.onClick?.(e);
                if (!e?.defaultPrevented) {
                    handleOpenChange(true);
                }
            },
        })
        : null;

    return (
        <>
            {trigger}

            <Dialog open={open} onOpenChange={handleOpenChange}>
                <DialogContent
                    className="p-0 m-0 rounded-xl h-fit max-h-[95vh] lg:max-h-[95vh] w-full border-none overflow-hidden flex flex-col lg:min-w-5xl">
                    <DialogTitle className="hidden">Join arthaverse</DialogTitle>
                    <JoinArthavaVerseForm profId={profId || ""} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default JoinArthaaverse;
